import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableRouteGoals = Loadable({
  loader: () => import('./RouteGoals.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableRouteGoals
